import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultipleVesselCreationComponent } from './multiple-vessel-creation.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    MultipleVesselCreationComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    MultipleVesselCreationComponent
  ]
})
export class MultipleVesselCreationModule { }
